import { Reveal, Stagger, StaggerItem } from "../components/Motion";
import { testimonials } from "../lib/data";

export default function Testimonials() {
  return (
    <div data-testid="page-testimonials">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">Відгуки</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              Голоси пацієнтів
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Реальні історії жінок, які звернулися до мене за красою, здоровʼям та впевненістю.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-luxe">
          <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((t, i) => (
              <StaggerItem key={i}>
                <div data-testid={`testimonial-${i}`} className="relative h-full p-8 md:p-10 rounded-3xl bg-sand/60 border border-line">
                  <div className="font-serif text-6xl absolute top-3 left-5 text-nudeDark leading-none">“</div>
                  <p className="pt-8 text-ink leading-relaxed">{t.quote}</p>
                  <div className="mt-8 pt-6 border-t border-line">
                    <div className="font-medium">{t.name}</div>
                    <div className="overline mt-1 text-warmGray">{t.location}</div>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
